import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { AuthTabs } from '@/components/Auth/AuthTabs';

// Ensure these paths match actual file locations
const BACKGROUND_IMAGES = [
  '/assets/images/login1.jpg',
  '/assets/images/login3.jpg',
  '/assets/images/login4.jpg',
];

export function AuthPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [backgroundImage, setBackgroundImage] = useState<string | null>(null);

  useEffect(() => {
    if (user) {
      navigate('/');
    }

    // Preload the image to ensure it's loaded before setting state
    const randomImage = BACKGROUND_IMAGES[Math.floor(Math.random() * BACKGROUND_IMAGES.length)];
    const img = new Image();
    img.src = randomImage;
    img.onload = () => setBackgroundImage(randomImage);
  }, [user, navigate]);

  return (
    <div className="flex min-h-screen flex-col lg:grid lg:grid-cols-2 lg:px-0">
      {/* Background Image Section */}
      <aside
        className="relative hidden lg:flex lg:flex-col lg:justify-between lg:bg-cover lg:bg-center lg:dark:border-r"
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
        }}
      >
        <div className="absolute inset-0 bg-black opacity-40" aria-hidden="true" />
        <header className="relative z-10 flex items-center text-lg font-medium text-white p-6">
          <img
            src="/assets/images/Gather_Icon.svg"
            alt="Gather Icon"
            className="mr-2 h-6 w-6"
            loading="lazy"
          />
          QS Tools
        </header>
      </aside>

      {/* Login Form Section */}
      <main className="flex flex-col items-center justify-center px-6 py-12 lg:p-8">
        <div className="mx-auto w-full max-w-md space-y-6">
          <AuthTabs />

          <footer className="text-center text-sm text-muted-foreground">
            By continuing, you agree to our{' '}
            <a 
              href="https://www.quantitysurveyortools.com/terms-of-service" 
              className="underline underline-offset-4 hover:text-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>{' '}
            and{' '}
            <a 
              href="https://www.quantitysurveyortools.com/privacy-policy" 
              className="underline underline-offset-4 hover:text-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>.
          </footer>
        </div>
      </main>
    </div>
  );
}
